module.exports = __webpack_public_path__ + "img/cello.be5030ca.webp";